<!--  -->
<template>
  <section class="project-task-section">
    <!-- :class="[isFullScreen && viewTask ? 'view-pdf-content' : '']" -->
    <div class="project-name-content">
      <div class="header-wrap">
        <span class="name-text title" :title="Train.trainingName"
          >项目名称：{{ Train.trainingName }}</span
        >
        <span
          class="name-edit label"
          v-if="userRole != 2"
          @click="updateProject"
          >修改</span
        >
      </div>
      <div class="teacher-info-wrap">
        <img
          :src="Train.photo ? photoBaseUrl + Train.photo : IconProfile"
          alt=""
        />
        <span :title="Train.createUserName">{{ Train.createUserName }}</span>
        <span :title="Train.roleName">{{ Train.roleName }}</span>
        <span :title="Train.orgsName">{{ Train.orgsName }}</span>
      </div>
      <div class="label-wrap">
        <span class="classify">
          <img :src="IconClassify" alt="" />
          <span> {{ trainingType }}</span>
        </span>
        <span class="create-time">
          <img :src="IconTime" alt="" />
          <span> {{ Train.createTime }}</span>
        </span>
      </div>
      <!-- 分割线 -->
      <el-divider></el-divider>
    </div>
    <div class="project-sliding-zone">
      <div class="project-description">
        <em class="title">任务描述</em>
        <p class="text">{{ Train.trainingContent }}</p>
      </div>
      <!-- 实训任务书 -->
      <div class="import-section project-import-task">
        <em class="title">实训任务书：</em>
        <div class="import-wrap">
          <div class="pdf-wrap">
            <img :src="iconPdf" v-if="Train.taskName" class="pdf-btn" alt="" />
            <span
              class="pdf-btn btn2"
              v-if="!Train.taskName"
              @click="upload('task')"
              >{{ userRole != 2 ? '导入实训任务书' : '暂无实训任务书' }}</span
            >
            <!-- <span v-else class="pdf-btn btn2">暂无实训任务书</span> -->
            <span class="pdf-name" v-if="Train.taskName">
              <em :title="Train.taskName">{{ Train.taskName | splitName }}</em>
            </span>
          </div>
          <div class="func-wrap" v-if="Train.taskName">
            <span class="label" @click="viewTaskPdf('task')" v-if="taskUrl"
              >查看</span
            >
            <span
              class="label"
              v-if="userRole != 2 && taskUrl"
              @click="deletePdf('task')"
              >删除</span
            >
          </div>
        </div>
      </div>
      <!-- 实训实训指导书 -->
      <div class="import-section project-import-guide-book">
        <em class="title">实训指导书：</em>
        <div class="import-wrap">
          <div class="pdf-wrap">
            <span
              class="pdf-btn btn2"
              v-if="!Train.guidanceName"
              @click="upload('guideBook')"
              >{{ userRole != 2 ? '导入实训指导书' : '暂无实训指导书' }}</span
            >
            <img
              v-if="Train.guidanceName"
              :src="iconPdf"
              class="pdf-btn"
              alt=""
            />
            <span class="pdf-name">
              <em :title="Train.guidanceName">{{
                Train.guidanceName | splitName
              }}</em>
            </span>
          </div>
          <div class="func-wrap" v-if="Train.guidanceName">
            <span
              class="label"
              @click="viewTaskPdf('guideBook')"
              v-if="guidanceUrl"
              >查看</span
            >
            <span
              class="label"
              @click="deletePdf('guideBook')"
              v-if="userRole != 2 && guidanceUrl"
              >删除</span
            >
          </div>
        </div>
      </div>
      <!-- 课程中的其它实训项目 -->
      <section class="other-training-section" v-if="userRole == 2">
        <p>课程中的其它实训项目</p>
        <ul class="other-training-list">
          <li class="task-item" v-for="(item, index) of taskList" :key="index">
            <span class="name ellipsis" :title="item.trainingName">{{ item.trainingName }}</span>
            <span class="label" @click="otherTraining(item)">去完成</span>
          </li>
        </ul>
        <div class="pagination-wrap" v-if="taskList && taskList.length > 0">
          <p class="left-arror" @click="changeTraining(0)"><span></span></p>
          <p class="center">
            <span class="pageNum">{{ pagination.pageNum }}</span
            >/<span>{{ pagination.pageCount }}</span>
          </p>
          <p class="right-arror" @click="changeTraining(1)"><span></span></p>
        </div>
      </section>
    </div>

    <!-- pdf 模块-->
    <div
      :class="{
        'pdf-view-content': true,
        'pdf-full-screen': isFullScreen,
        'pdf-normal-screen': !isFullScreen,
      }"
      v-show="viewTask"
    >
      <header class="pdf-headr">
        <!-- pdf分页 -->
        <!-- <p class="arrow">
          <el-pagination
            small
            layout="prev, pager, next"
            :total="pdfObj.pageCount"
            :page-size="1"
            :current-page.sync="pdfObj.currentPage"
            @prev-click="changePdfPage(0)"
            @next-click="changePdfPage(1)"
            @current-change="getPdfPage"
          >
          </el-pagination>
        </p> -->
        <!-- 全屏/退出全屏按钮 -->
        <span
          class="full-screen"
          :title="
            isFullScreen
              ? Icons.ExitFullScreen.iconName
              : Icons.FullScreen.iconName
          "
          v-show="sidebarSwitch"
          @click="fullScreen"
        >
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.FullScreen.iconName"
            v-bind="Icons.FullScreen"
            v-show="!isFullScreen"
          >
            <icon-full-screen />
          </icon-base>
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.ExitFullScreen.iconName"
            v-bind="Icons.ExitFullScreen"
            v-show="isFullScreen"
          >
            <icon-exit-full-screen />
          </icon-base>
        </span>
        <!-- 关闭 -->
        <span @click="pdfClose">
          <icon-base
            class="icon-close"
            :icon-name="Icons.PopupClose.iconName"
            v-bind="Icons.PopupClose"
          >
            <icon-popup-close />
          </icon-base>
        </span>
      </header>

      <div class="line"></div>
      <iframe
        class="iframe-pdf"
        v-if="pdfUrl && pdfStatus"
        :src="basePdfApi + pdfUrl"
        width="100%"
        height="100%"
        frameborder="0"
      ></iframe>

      <!-- <pdf
          v-if="pdfStatus"
          :src="pdfUrl"
          :page="pdfObj.currentPage"
          @click="viewTask = false"
          @num-pages="pdfObj.pageCount = $event"
          @page-loaded="pdfObj.currentPage = $event"
          @loaded="loadPdfHandler"
        >
          >
        </pdf> -->
      <!-- </div> -->
    </div>
    <div class="popup-list">
      <!-- 保存并提交 -->
      <gat-popup
        :class="['popup-submit-save', popupActive === 'update' ? 'on' : 'off']"
        :title="'实训项目修改'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="confirmUpdate"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            ref="submitProject"
            :model="Train"
            label-width="100px"
          >
            <el-form-item label="项目名称：">
              <el-input
                placeholder="请输入项目名称"
                v-model.trim="Train.trainingName"
                maxlength="25"
                show-word-limit
              />
            </el-form-item>
            <el-form-item label="项目描述：">
              <el-input
                v-model.trim="Train.trainingContent"
                type="textarea"
                placeholder="请输入项目描述"
                :rows="7"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
    </div>
  </section>
</template>

<script>
import bus from '@/utils/bus'
// import pdf from 'vue-pdf'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import COMMON from '@/axios/common/common.js'
import IconFullScreen from '@/components/icons/typography/FullScreen'
import IconExitFullScreen from '@/components/icons/typography/ExitFullScreen'
import IconPopupClose from '@/components/icons/typography/PopupClose'
import GatPopup from '@/components/common/GatPopup'
import { mapGetters } from 'vuex'

export default {
  name: 'aiBookTask',
  //import引入的组件需要注入到对象中才能使用
  components: {
    // pdf,
    IconFullScreen,
    IconExitFullScreen,
    IconPopupClose,
    GatPopup,
  },
  props: {
    // 实训ID
    trainingId: {
      type: String,
      default: null,
    },
    // 实训ID
    Train: {
      type: Object,
      default() {
        return { taskUrl: '', guidanceUrl: '' }
      },
    },
    sidebarSwitch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewType: 'task', //task为任务书,guideBook为指导书
      taskUrl: '', //任务书文档;
      guidanceUrl: '', //指导书文档;
      viewTask: false,
      viewGuideBook: false,
      taskList: [],
      traningTypes: [], //实训编辑类型
      pagination: {
        pageNum: 1,
        pageSize: 4,
        total: null,
        pageCount: null,
      },
      pdfObj: {
        currentPage: 1, // pdf文件页码
        pageCount: 2, // pdf文件总页数
        fileType: 'pdf', // 文件类型
      },
      pdfStatus: true,
      fileType: 'pdf', // 文件类型
      popupActive: '',
      Icons: {
        FullScreen: {
          iconName: '全屏',
          viewBox: '0 0 19 19',
          width: '19',
          height: '19',
        },
        ExitFullScreen: {
          iconName: '退出全屏',
          viewBox: '0 0 21 21',
          width: '21',
          height: '21',
        },
        PopupClose: {
          iconName: '关闭',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
        },
      },
      isFullScreen: false,
      IconProfile: require('@/assets/images/ai-editor/profile03.png'),
      IconTime: require('@/assets/images/ai-editor/icon-time.png'),
      IconProjectQuestion2: require('@/assets/images/ai-editor/project-question2.png'),
      IconClassify: require('@/assets/images/ai-editor/icon-classify.png'),
      iconPdf: require('@/assets/images/ai-editor/PDF.png'),
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      basePdfApi: window.gtaAiConfig.basePdfApi, // pdfApi基地址配置
      pdfUrl: '',
    }
  },
  filters: {
    splitName: (val) => {
      let text
      if (val && val.length > 8) {
        text = val.substring(0, 8) + '...'
      } else {
        text = val
      }
      return text
    },
  },
  //监控data中的数据变化
  watch: {
    sidebarSwitch: {
      handler: function(val) {
        if (!val) {
          this.viewTask = false
        }
      },
      immediate: true,
    },
    'Train.taskUrl': {
      handler: function(val) {
        let taskUrl = val,
          new_service_data = window.new_service_data,
          reg = new RegExp(new_service_data),
          env = process.env.NODE_ENV
        // if (val) {
        // taskUrl = taskUrl.replace(reg, "/new_service_data");
        // }
        this.taskUrl = this.photoBaseUrl + taskUrl
      },
      immediate: true,
    },
    'Train.guidanceUrl': {
      handler: function(val) {
        let guidanceUrl = val,
          new_service_data = window.new_service_data,
          reg = new RegExp(new_service_data),
          env = process.env.NODE_ENV
        // if (val && env !== 'production') {
        //   // guidanceUrl = guidanceUrl.replace(reg, '/new_service_data')
        //   // console.log('guidanceUrl', guidanceUrl)
        // }
        this.guidanceUrl = this.photoBaseUrl + guidanceUrl
      },
      immediate: true,
    },
    viewTask(val) {
      if (this.isFullScreen && val) {
        this.$parent.pdfViewFullScreen = true
      } else {
        this.$parent.pdfViewFullScreen = false
      }
    },
    isFullScreen(val) {
      if (this.viewTask && val) {
        this.$parent.pdfViewFullScreen = true
      } else {
        this.$parent.pdfViewFullScreen = false
      }
    },
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'curriculumId', 'userRole']),
    trainingType() {
      let type = this.Train.type,
        val
      val =
        type == 1
          ? '算法编程应用'
          : type == 2
          ? '智能硬件应用'
          : type == 3
          ? '数据标注应用'
          : '行业创研应用'
      return val
    },
    // pdfUrl: {
    //   set(val) {
    //     return val
    //   },
    //   get() {
    //     let viewType = this.viewType
    //     if (viewType === 'task') {
    //       console.log('this.taskUrl', this.taskUrl)
    //       if(this.taskUrl &&!/undefined/.test(this.taskUrl)){
    //         return this.taskUrl
    //       }
    //       return ''
    //     } else {
    //       console.log('this.guidanceUrl', this.guidanceUrl)
    //       if(this.guidanceUrl&&!/undefined/.test(this.guidanceUrl)){
    //         return this.guidanceUrl
    //       }
    //       return ''
    //     }
    //   },
    // },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.taskFile = pdf.createLoadingTask(this.taskFile);
    if (this.userRole == 2) {
      this.getOtherTrainingByCurriculumId() //查询其他实训列表数据
    }
    this.getTrainingTypeApi()
  },
  mounted() {},
  methods: {
    /**
     *
     * 其他项目实训处理方法
     * */
    // 学生查询其它项目列表数据  @data curriculumId 课程id  pageNum pageSize trainingId
    async getOtherTrainingByCurriculumId() {
      let { pagination, curriculumId, trainingId } = this,
        data = {}
      data = {
        pageNum: pagination.pageNum,
        pageSize: pagination.pageSize,
        curriculumId,
        trainingId,
      }
      let res = await PROJECTS.getOtherTrainingByCurriculumId(data)
      if (res && res.isSuccess) {
        this.taskList = res.data.records
        this.pagination.total = res.data.total
        this.pagination.pageCount = Math.ceil(
          res.data.total / this.pagination.pageSize
        )
      }
    },
    //跳转去其他实训
    async otherTraining(item) {
      if (!item) return

      // await bus.$emit('aiEditorSaveFile', 3) //触发保存代码
      let res = await this.$parent.$parent.saveFile(3)

      if (item.type === 3) {
        // 数据标注
        if (item.status === 2 && this.userRole != 2) {
          this.$router.push({
            name: 'training-model',
            query: {
              trainingId: item.trainingId,
              modelType: item.editorType,
            },
          })
        } else {
          this.$router.push({
            name: 'training-model',
            query: {
              curriculumId: item.curriculumId,
              trainingId: item.trainingId,
              modelType: item.editorType,
              userId: item.createBy,
              // isComplete: item.isComplete
            },
          }) // 标注页面
        }
      } else {
        // 创建新任务
        this.redirectToProject(item)
      }
      // if (item.type === 3) {
      //   // 数据标注 学生角色
      //   this.$router.push({
      //     name: 'training-model',
      //     query: { trainingId: item.trainingId, isComplete: item.isComplete },
      //   }) // 标注页面
      // } else {
      //   this.$router.push({
      //     name: 'training-model',
      //     query: {
      //       trainingId: item.trainingId,
      //       trainingName: item.trainingName,
      //       type: item.type,
      //       createBy: item.createBy,
      //       curriculumId: item.curriculumId,
      //     },
      //   })
      // }
      // window.location.reload() //重新刷新页面
    },
    //实训-重定向到不同类别的编辑器
    redirectToProject(project) {
      let dictTypeDesc, queryName, path
      this.traningTypes.forEach((item) => {
        if (item.dictId == project.editorType) {
          dictTypeDesc = item.dictTypeDesc
        }
      })

      if (/(?=.*AI-T).*(?=.积木模式)/i.test(dictTypeDesc)) {
        queryName = 'training-editor-block'
        path = '/training/editor/block'
      } else if (/AI-T/i.test(dictTypeDesc)) {
        queryName = 'training-editor-ai-python'
        path = '/training/editor/ai/python'
      } else if (/海龟|基础/i.test(dictTypeDesc)) {
        queryName = 'training-editor-baseBlock'
        path = '/training/editor/baseBlock'
      }

      this.$router.push({
        name: queryName,
        query: {
          trainingId: project.trainingId,
          trainingName: project.trainingName,
          type: project.type,
          createBy: project.createBy,
          curriculumId: project.curriculumId,
          editorType: project.editorType,
          quoteTrainingId: project.quoteTrainingId,
        },
      })
      setTimeout(() => {
        this.$router.go(0)
      }, 100);
      // let pathname = window.location.pathname
      // if (pathname === path) {
      //   this.$router.go(0)
      // }
    },
    changeTraining(type) {
      if (type === 0) {
        if (this.pagination.pageNum !== 1) {
          this.pagination.pageNum--
          this.getOtherTrainingByCurriculumId()
        }
      } else {
        if (this.pagination.pageNum < this.pagination.pageCount) {
          this.pagination.pageNum++
          this.getOtherTrainingByCurriculumId()
        }
      }
    },
    changeTraining2(val) {
      this.pagination.pageNum = val
      this.getOtherTrainingByCurriculumId()
    },
    /**
     *
     * 上传和删除pdf处理方法
     * */
    // 上传
    upload(fileType) {
      let self = this
      if (this.userRole == 2) {
        return
      }
      let inputNode = document.createElement('input')
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('accept', 'application/*') // 支持doc、ppt、xls、等文件的上传
      inputNode.setAttribute('multiple', 'false') //单文件上传
      inputNode.click()
      // 文件上传过程
      inputNode.onchange = async function uploadFile(evt) {
        // 获取 file
        let file = evt.target.files[0],
          fileList = evt.target.files,
          list = Array.from(fileList),
          formatPass,
          ppt_match = /.pdf/i

        formatPass = self.$util.filesFormatEveryCheck(list, ppt_match)
        if (!formatPass) {
          self.$message({
            message: '上传失败，请上传PDF文件！',
            type: 'error',
            duration: 2000,
          })
          return
        }

        const loading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        setTimeout(() => {
          loading.close() // 超过10秒时关闭loading效果
        }, 1000 * 10)

        // 实例化
        var fileName = file.name
        //截取名称长度
        fileName = fileName.slice(0, 10)

        let formdata = new FormData()
        formdata.append('file', file)
        let res = await COMMON.UploadFile(formdata)
        // console.log('res', res)
        if (res && res.returnCode == 200) {
          self.$message({
            message: '上传成功！',
            type: 'success',
            duration: 2000,
          })

          let files = res.data,
            data,
            res2,
            fileUrl = self.photoBaseUrl + files.url

          if (fileType == 'task') {
            data = {
              trainingId: self.trainingId,
              taskUrl: files.url,
              taskName: files.fileName,
            }
            //上传实训任务书接口
            res2 = await PROJECTS.uploadTrainingTask(data)
          } else if (fileType == 'guideBook') {
            data = {
              trainingId: self.trainingId,
              guidanceUrl: files.url,
              guidanceName: files.fileName,
            }
            // 上传实训实训指导书接口
            res2 = await PROJECTS.uploadTrainingGuidance(data)
          }

          if (res2 && res2.isSuccess) {
            self.pdfObj.currentPage = 1
            self.pdfUrl = ''

            self.$emit('getTrainingByTrainingId') //父组件重新获取项目信息
          } else {
            self.$message({
              message: '上传的文件保存失败！',
              type: 'error',
              duration: 2000,
            })
          }
          loading.close()
        } else {
          loading.close()
          self.$message({
            message: '上传失败！',
            type: 'error',
            duration: 2000,
          })
        }
      }
    },
    //删除pdf文件
    async deletePdf(fileType) {
      let { trainingId } = this,
        { taskUrl, guidanceUrl } = this.Train,
        data = {},
        res

      //调用删除接口
      if (fileType === 'task') {
        if (!taskUrl) return this.$message.warning('没有文档')
        data = { trainingId, taskUrl }
        res = await PROJECTS.deleteTrainingTask(data)
      } else {
        if (!guidanceUrl) return this.$message.warning('没有文档')
        data = { trainingId, guidanceUrl }
        res = await PROJECTS.deleteTrainingGuidance(data)
      }

      if (res && res.isSuccess) {
        //初始化taskUrl 或 guidanceUrl
        if (fileType === 'task') {
          this.taskUrl = ''
        } else {
          this.guidanceUrl = ''
        }
        this.pdfStatus = false
        await this.$emit('getTrainingByTrainingId') //父组件重新获取项目信息
        this.pdfStatus = true
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 2000,
        })
      } else {
        this.$message({
          message: '删除失败',
          type: 'error',
          duration: 2000,
        })
      }
    },
    /**
     *
     *
     * 项目修改处理方法
     * */
    updateProject() {
      this.popupActive = 'update'
    },
    async confirmUpdate() {
      let { trainingName, trainingContent } = this.Train
      let { trainingId } = this
      if (!trainingName || !trainingContent) {
        let msgName = trainingName ? '项目描述不能为空！' : '项目名称不能为空！'
        return this.$message({
          message: msgName,
          type: 'error',
          duration: 2000,
        })
      }
      let data = { trainingId, trainingName, trainingContent }
      let res = await PROJECTS.updateTraining(data)
      if (res && res.isSuccess) {
        this.$emit('getTrainingByTrainingId') //父组件重新获取项目信息
        this.$message({
          message: '修改成功！',
          type: 'success',
          duration: 2000,
        })
      } else {
        this.$message({
          message: '修改失败！',
          type: 'error',
          duration: 2000,
        })
      }
      this.popupActive = ''
    },
    cancelPopup() {
      this.popupActive = ''
    },
    /**
     *
     *
     * pdf查看处理方法
     * */
    viewTaskPdf(viewType) {
      if (
        (viewType == 'task' && !this.taskUrl) ||
        (viewType == 'guideBook' && !this.guidanceUrl)
      ) {
        return this.$message.warning('没有文档')
      }
      if (viewType == 'task') {
        this.pdfUrl = this.taskUrl
      } else {
        this.pdfUrl = this.guidanceUrl
      }
      //和上一次查看的内容比较
      if (this.viewType !== viewType) {
        this.pdfObj.currentPage = 1
      }
      this.viewTask = true
      this.viewType = viewType
    },
    fullScreen() {
      // TODO: 全屏操作
      this.isFullScreen = !this.isFullScreen
    },
    pdfClose() {
      // TODO: 全屏操作
      this.isFullScreen = false
      this.viewTask = false
      this.viewGuideBook = false
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.pdfObj.currentPage > 1) {
        this.pdfObj.currentPage--
      }
      if (val === 1 && this.pdfObj.currentPage < this.pdfObj.pageCount) {
        this.pdfObj.currentPage++
      }
    },
    getPdfPage(val) {
      this.pdfObj.currentPage = val
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.pdfObj.currentPage = 1 // 加载的时候先加载第一页
    },
    getTrainingTypeApi() {
      let data = {
        dictTypeCode: 'EditorType',
      }
      return PROJECTS.getTrainingType(data)
        .then((res) => {
          if (res && res.returnCode == 200) {
            this.traningTypes = res.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  }, // methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.project-task-section {
  height: 100%;
  padding: 0px 20px;
  color: #fefeff;
  position: relative;
  .title {
    color: #fefeff;
    font-size: 16px;
    font-family: 'MicrosoftYaHei-Bold';
  }
  .label {
    font-size: 14px;
    color: #4c88ff;
    cursor: pointer;
    margin-left: 12px;
  }
  .project-name-content {
    width: 100%;
    .header-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      .name-text {
        flex: 1;
        color: #fefeff;
        font-size: 16px;
        font-family: 'MicrosoftYaHei-Bold';
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .teacher-info-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: rgba(153, 153, 153, 1);
      img {
        width: 16px;
        height: 16px;
        border-radius: 8px;
      }
      span {
        max-width: 65px;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:last-child {
          max-width: 100%;
          flex: 1;
        }
      }
    }
    .label-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 20px;

      font-size: 13px;
      color: #999;
      .classify {
        span {
          opacity: 0.6;
          margin-left: 8px;
        }
      }
      .create-time {
        margin-left: 28px;
        span {
          opacity: 0.6;
          margin-left: 8px;
        }
      }
    }
    .el-divider {
      background-color: #253a76;
    }
  }

  // 滑动区
  .project-sliding-zone {
    width: 100%;
    // height: 62vh;
    height: calc(100vh - 345px);
    overflow: auto;

    &::-webkit-scrollbar {
      width: 16px; /*滚动条宽度*/
      height: 16px; /*滚动条高度*/
    }

    /*定义滚动条轨道 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      border-radius: 10px; /*滚动条的背景区域的圆角*/
      background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
    }

    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 10px; /*滚动条的圆角*/
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
    }
  }

  .project-description {
    // min-height: 100px;
    max-height: 240px;
    overflow: auto;
    padding-bottom: 10px;
    .text {
      color: #d0dcff;
      font-size: 14px;
      padding: 20px 0px;
      text-align: justify;
      text-justify: newspaper;
      word-break: break-all;
    }
  }
  .import-section {
    .import-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      .pdf-wrap {
        display: flex;
        align-items: center;
        .pdf-btn {
          cursor: pointer;
        }
        .pdf-name {
          color: #9a7cff;
          font-size: 15px;
          margin-left: 13px;
        }
      }
    }
    &.project-import-task {
      .btn2 {
        display: inline-block;
        padding: 5px;
        font-size: 14px;
        background: rgba(154, 124, 255, 0.3);
        color: #c7b6ff;
        border-radius: 17px;
      }
    }
    &.project-import-guide-book {
      margin-top: 20px;
      .btn2 {
        display: inline-block;
        padding: 5px;
        font-size: 14px;
        background: rgba(154, 124, 255, 0.3);
        color: #c7b6ff;
        border-radius: 17px;
      }
    }
  }
}
.pdf-view-content {
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #fff;
  // overflow: auto;
  .iframe-pdf {
    height: calc(100% - 40px);
  }
  &.pdf-normal-screen {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .pdf-headr {
      width: 100%;
    }
    .arrow {
      top: 7px;
      left: 10px;
      color: #666;
      position: absolute;
      width: 50%;
    }
    .full-screen {
      top: 10px;
    }
    .icon-close {
      top: 13px;
    }
  }
  &.pdf-full-screen {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    > span {
      position: absolute;
      width: 70%;
      height: auto;
      left: 50%;
      transform: translate(-50%, 0%);
    }
    .pdf-headr {
      width: 70%;
    }
    .arrow {
      padding-top: 10px;
    }
    .full-screen {
      top: 20px;
    }
    .icon-close {
      top: 23px;
    }
  }
  .line {
    width: 100%;
    border-bottom: 1px solid #ccc;
  }
  .pdf-headr {
    top: 0px;
    min-height: 30px;
    height: 5%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    .full-screen {
      display: inline-block;
      position: absolute;
      right: 30px;
      // top: 10px;
      cursor: pointer;
      // .icon-full-screen {
      // }
    }
  }

  .icon-close {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 13px;
    cursor: pointer;
  }

  ::v-deep.el-icon-arrow-left:before,
  ::v-deep.el-icon-arrow-right:before {
    font-size: 20px;
  }
}
.popup-list {
  .popup-submit-save {
    &.off {
      display: none;
    }
    &.on {
      display: inline-block;
    }
    &::v-deep .popup-inner {
      width: 580px;
      height: 100%;
      max-height: 48%;
      .popup-content {
        margin-top: 20px;
        .el-form {
          width: 96%;
          .el-form-item {
            margin-bottom: 20px;
          }
        }
        .score-text {
          margin-top: 20px;
        }
      }
    }
  }
}
.other-training-section {
  margin-top: 30px;

  .other-training-list {
    width: 100%;
    // margin-top: 30px;
    color: #8cafff;
    font-size: 15px;
    li {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 20px 0 0 0;
      .name {
        flex: 1;
      }
    }
  }
  .pagination-wrap {
    // float: right;
    background-color: none;
    background: none;
    text-align: right;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    // position: absolute;
    // bottom: -30px;
    // right: 20px;
    .center {
      margin: 0 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #4c88ff;
      font-size: 14px;
      .pageNum {
        color: #fff;
      }
    }
    .left-arror,
    .right-arror {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      width: 22px;
      height: 22px;
      background: rgba(76, 136, 255, 0.4);
      border-radius: 3px;
      cursor: pointer;
    }
    .left-arror {
      span {
        width: 0;
        height: 0;
        border-top: 4px solid transparent;
        border-right: 7px solid #fff;
        border-bottom: 4px solid transparent;
        display: inline-block;
      }
    }
    .right-arror {
      span {
        width: 0;
        height: 0;
        border-top: 4px solid transparent;
        border-left: 7px solid #fff;
        border-bottom: 4px solid transparent;
        display: inline-block;
      }
    }
  }
}
.dispermited {
  pointer-events: none;
  opacity: 0.5;
}
</style>
